import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

/**
 * Регистрация модулей ag-grid (аналог AgGridCommunity.kt + Main.kt:7-9 в fullWeb).
 * Вынесено отдельно, чтобы тесты получали ту же конфигурацию, что и приложение.
 */
export function setupAgGrid(): void {
  ModuleRegistry.registerModules([AllCommunityModule]);
}
